import { createReducer } from '@reduxjs/toolkit';
import * as actions from '../actions';
import { NotificationsPushTokenState } from '../types';

export const pushTokenInitialState: NotificationsPushTokenState = {
  tokenType: null,
  tokenAddress: null
};

const notificationsPushTokenReducer = createReducer(pushTokenInitialState, {
  [actions.SET_PUSH_TOKEN_INFO]: (state, action) => {
    const { tokenType, tokenAddress } = action.payload;
    state.tokenType = tokenType;
    state.tokenAddress = tokenAddress;
  }
});

export default notificationsPushTokenReducer;
